// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1JQpD","additionalInfo":"AgreementModal_additionalInfo__1kG2y"};